// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { featuredProductsCardStyles } from "@guestsupply/App/Components/Header/FeaturedProductsCard";
import { createProductDescriptionStyles } from "@guestsupply/App/SharedStyles/productDescriptionStyles";
import { createHorizontalSmallHeadingAndTextStyles } from "@guestsupply/App/SharedStyles/smallHeadingAndTextStyles";
import { mergeWithCss } from "@guestsupply/XDL/Utilities/mergeWithCss";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

featuredProductsCardStyles.wrapper = {
    css: css`
        display: flex;
        margin-bottom: 8px;
        padding: 9px;
        background-color: ${getColor("common.white")};
        border-radius: 4px;
        border: 1px solid ${getColor("common.border")};
    `,
};
featuredProductsCardStyles.imageLink = {
    css: css`
        &&& {
            width: 98px;
            min-width: 98px;
            height: auto;
            height: 98px;
            ${TypographyStyle} {
                display: flex;
                max-height: 100%;
            }
        }
        margin-right: 12px;
    `,
};
featuredProductsCardStyles.image = {
    css: css`
        max-width: 100%;
        max-height: 100%;
        height: auto;
        img {
            border-radius: 4px;
            max-height: 100%;
            width: auto;
        }
    `,
};

featuredProductsCardStyles.titleLink = {
    ...mergeWithCss(createProductDescriptionStyles().productDetailLink, {
        typographyProps: {
            css: css`
                &&& {
                    font-size: 12px;
                }
            `,
        },
        css: css`
            min-height: initial;
        `,
    }),
};
featuredProductsCardStyles.erpNumberText = {
    ...createHorizontalSmallHeadingAndTextStyles({
        wrapper: {
            css: css`
                margin-bottom: 12px;
            `,
        },
    }),
};
featuredProductsCardStyles.contentWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};
featuredProductsCardStyles.productActionsStyle = {
    addToCartContainer: {
        css: css`
            margin-top: auto;
        `,
    },
};
